// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".eecfd0f0c98980aff242bff02f5470fa79908707.chunk.js";
};